'use client';

import { Flex } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import './SearchResultPage.scss';

import { loadSearchResultsPageScript } from '@/utils/loadScript';

const SearchResultPage = () => {
  useEffect(() => {
    loadSearchResultsPageScript();
  }, []);

  return (
    <Flex className={'search-result-page-container'}>
      <Flex className={'search-result-page'}>
        <Flex id={'searchsg-result-container'} />
      </Flex>
    </Flex>
  );
};

export default SearchResultPage;
